import { render, staticRenderFns } from "./customCss.vue?vue&type=template&id=f987609c&scoped=true&"
import script from "./customCss.vue?vue&type=script&lang=js&"
export * from "./customCss.vue?vue&type=script&lang=js&"
import style0 from "./customCss.vue?vue&type=style&index=0&id=f987609c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f987609c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VIcon,VRow})
